<template>
  <v-container fluid class="pa-0">
    <v-card class="mx-auto my-4" elevation="2">
      <v-card-title class="headline">Filtros</v-card-title>

      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row>
            <v-col cols="12" md="6" class="d-flex">
              <v-autocomplete
                v-model="agroSelected"
                :items="agroindustrias"
                item-text="pessoa.pessoajuridica.NomeFantasia"
                item-value="CodAgroindustria"
                label="Agroindústria"
                clearable
                multiple
                hide-details="auto"
                :loading="loadingFilter.agroindustria"
              />
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <v-autocomplete
                v-model="statusSelected"
                :items="status"
                item-text="text"
                item-value="value"
                label="Status Fazenda"
                clearable
                hide-details="auto"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="d-flex">
              <v-autocomplete
                v-model="supervisorSelected"
                :items="supervisores"
                item-text="Nome"
                item-value="user_id"
                label="Supervisor"
                clearable
                multiple
                hide-details="auto"
                :loading="loadingFilter.supervisor"
              />
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <v-autocomplete
                v-model="consultorSelected"
                :items="consultores"
                item-text="Nome"
                item-value="id"
                label="Consultor"
                clearable
                multiple
                hide-details="auto"
                :loading="loadingFilter.consultor"
              />
            </v-col>
            <v-col cols="12" md="6" class="d-flex">
              <v-autocomplete
                v-model="produtorSelected"
                :items="produtores"
                item-text="name"
                item-value="id"
                label="Produtor"
                clearable
                multiple
                hide-details="auto"
                :loading="loadingFilter.produtor"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>

    <v-row align="center" justify="start">
      <v-col cols="6">
        <v-autocomplete
          v-model="modelo"
          :items="apiModelos"
          item-text="title"
          return-object
          label="Modelo"
          outlined
          dense
          hide-details
          clearable
          :loading="loadingModelo"
          :disabled="loadingModelo"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action class="my-0">
              <!-- .stop impede que o clique na lixeira também selecione o item -->
              <v-btn
                icon
                small
                color="error"
                title="Excluir modelo"
                @click.stop="deleteExtractModel(item)"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-btn color="primary" dark block @click="selectExtactModel">
          Carregar
          <v-icon dark right> mdi mdi-table-arrow-down </v-icon>
        </v-btn>
      </v-col>

      <v-col cols="3">
        <v-btn color="success" dark block @click="dialog = true">
          Salvar
          <v-icon dark right> mdi mdi-content-save </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-autocomplete
          v-model="currentSelection.field"
          :items="apiFields"
          item-text="field_label"
          return-object
          label="Selecione o campo"
          outlined
          dense
          hide-details
          clearable
          :loading="loadingField"
          :disabled="loadingField"
        ></v-autocomplete>
      </v-col>

      <v-col cols="3">
        <v-select
          v-model="currentSelection.calc"
          :items="filteredCalculationTypes"
          item-text="text"
          return-object
          label="Cálculo"
          outlined
          dense
          hide-details
          :disabled="!currentSelection.field"
        ></v-select>
      </v-col>

      <v-col cols="3">
        <v-btn
          color="primary"
          dark
          block
          :disabled="!currentSelection.field"
          @click="addEntry"
        >
          Adicionar
          <v-icon dark right> mdi-plus </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="extractedDataArray.length > 0">
      <v-col cols="12">
        <v-card>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="blue darken-4 white--text text-left">Campo</th>
                  <th class="blue darken-4 white--text text-left">Cálculo</th>
                  <th
                    class="blue darken-4 white--text text-center"
                    style="width: 100px"
                  >
                    Ação
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in extractedDataArray" :key="index">
                  <td>{{ item.fieldLabel }}</td>
                  <td>{{ item.calcText }}</td>
                  <td class="text-center">
                    <v-btn icon small color="error" @click="removeEntry(index)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-col>

      <v-card class="mx-auto my-4" elevation="2">
        <!-- <v-card-title class="headline">Filtros de Extração</v-card-title> -->

        <v-card-text>
          <v-container fluid class="pa-0">
            <v-row class="mt-4" align="center">
              <v-col cols="12" sm="5" md="4">
                <v-menu
                  v-model="menuDataIni"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="moment(dataInicio).format('DD/MM/YYYY')"
                      label="Data Inicial"
                      prepend-icon="mdi-calendar"
                      color="teal"
                      readonly
                      hide-details="auto"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="dataInicio"
                    :max="dataFim"
                    color="teal"
                    locale="pt-br"
                    @input="menuDataIni = false"
                  />
                </v-menu>
              </v-col>

              <v-col cols="12" sm="5" md="4">
                <v-menu
                  v-model="menuDataFim"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="moment(dataFim).format('DD/MM/YYYY')"
                      color="teal"
                      label="Data Final"
                      prepend-icon="mdi-calendar"
                      readonly
                      hide-details="auto"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="dataFim"
                    :min="dataInicio"
                    :max="dataLimite"
                    color="teal"
                    locale="pt-br"
                    @input="menuDataFim = false"
                  />
                </v-menu>
              </v-col>

              <v-col
                cols="12"
                sm="2"
                md="4"
                class="d-flex justify-end align-center"
              >
                <v-btn
                  color="success"
                  dark
                  :block="$vuetify.breakpoint.xsOnly"
                  @click="extract()"
                >
                  <v-icon left>mdi-microsoft-excel</v-icon>
                  Extrair
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-row>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h3 primary white--text">
          Criar Modelo de Extração
        </v-card-title>

        <v-card-text class="mt-4">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="nomeModelo"
                  label="Nome do Modelo*"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          <v-btn color="red" dark @click="dialog = false"> Cancelar </v-btn>

          <v-btn color="success" @click="createExtractModel"> Confirmar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ExtractServices from '../../../services/api/extractData'
import { JsonToExcel } from '../../../utils/Worksheet'
import { ENV_APP } from '../../../../env'
import agroindustryService from '../../../services/api/agroindustry'
import consultantService from '../../../services/api/consultant'
import supervisorService from '../../../services/api/supervisor'
import producerService from '../../../services/api/producers'
import Swal from 'sweetalert2'

export default {
  name: 'ExtractData',
  props: {
    reportTypeId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      dataLimite: this.moment().toISOString(true).substr(0, 10),
      menuDataIni: false,
      menuDataFim: false,

      modelo: null,
      nomeModelo: null,
      apiModelos: [],

      loadingModelo: false,
      dialog: false,

      dataInicio: this.moment()
        .startOf('month')
        .toISOString(true)
        .substr(0, 10),
      dataFim: this.moment().endOf('month').toISOString(true).substr(0, 10),

      apiFields: [],
      agroindustrias: [],
      supervisores: [],
      produtores: [],
      consultores: [],
      loadingField: false,
      loadingFilter: {
        agroindustria: false,
        supervisor: false,
        consultor: false,
        produtor: false,
      },
      loadingSheet: false,
      calculationTypes: [
        {
          value: 'soma',
          text: 'Soma',
          allowed: ['numeric', 'number-pad'],
        },
        {
          value: 'media',
          text: 'Média',
          allowed: ['numeric', 'number-pad'],
        },
        {
          value: 'detalhado',
          text: 'Detalhado',
          allowed: 'all', // Marcador especial para aceitar tudo
        },
      ],
      currentSelection: {
        field: null,
        calc: { value: 'soma', text: 'Soma' },
      },
      status: [
        {
          text: 'Todos',
          value: null,
        },
        {
          text: 'Ativo',
          value: '1',
        },
        {
          text: 'Inativo',
          value: '0',
        },
      ],
      extractedDataArray: [],
      agroSelected: [],
      supervisorSelected: [],
      produtorSelected: [],
      consultorSelected: [],
      statusSelected: null,
    }
  },
  computed: {
    filteredCalculationTypes() {
      const field = this.currentSelection && this.currentSelection.field
      const tipoDoCampo = field ? field.field_type : null

      return this.calculationTypes.filter(calc => {
        // 'detalhado' aparece sempre (allowed: 'all')
        if (calc.allowed === 'all') return true

        // Se não houver tipo definido, só mostra o 'detalhado'
        if (!tipoDoCampo) return false

        return calc.allowed.includes(tipoDoCampo)
      })
    },
  },
  watch: {
    reportTypeId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchApiFields(newId)
        } else {
          this.apiFields = []
          this.extractedDataArray = []
        }
      },
    },
    'currentSelection.field': function () {
      this.currentSelection.calc = null
    },
  },
  methods: {
    async loadExtractModel() {
      try {
        this.loadingModelo = true
        return await ExtractServices.extractList(
          this.reportTypeId,
          ENV_APP.ProjectID,
        )
      } finally {
        this.loadingModelo = false
      }
    },

    async createExtractModel() {
      Swal.fire({
        title: 'Salvando modelo...',
        text: 'Por favor, aguarde.',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      let data = {
        title: this.nomeModelo,
        reportTypeId: this.reportTypeId,
        projectId: ENV_APP.ProjectID,
        dados: this.extractedDataArray,
      }

      try {
        await ExtractServices.extractSave(data)
        this.apiModelos = await this.loadExtractModel()
        this.nomeModelo = null
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Modelo criado com sucesso.',
          timer: 2000,
          showConfirmButton: false,
        })

        this.dialog = false
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao salvar',
          text: 'Ocorreu um problema ao tentar salvar o modelo.',
        })
      }
    },

    async deleteExtractModel(modeloToDelete) {
      document.activeElement?.blur()

      const { isConfirmed } = await Swal.fire({
        icon: 'warning',
        title: 'Excluir modelo?',
        text: `O modelo "${modeloToDelete.title}" será excluído.`,
        showCancelButton: true,
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
        reverseButtons: true,
      })

      if (!isConfirmed) return

      Swal.fire({
        title: 'Excluindo modelo...',
        text: 'Por favor, aguarde.',
        allowOutsideClick: false,
        showConfirmButton: false,
      })
      Swal.showLoading()

      try {
        await ExtractServices.extractDelete(modeloToDelete.id)

        this.apiModelos = this.apiModelos.filter(
          ({ id }) => id !== modeloToDelete.id,
        )
        if (this.modelo && this.modelo.id === modeloToDelete.id) {
          this.modelo = null
        }

        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Modelo excluído com sucesso.',
          timer: 2000,
          showConfirmButton: false,
        })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao excluir',
          text: 'Ocorreu um problema ao tentar excluir o modelo.',
        })
        throw error
      }
    },

    selectExtactModel() {
      if (this.modelo) {
        this.extractedDataArray = JSON.parse(this.modelo.dados)
      }
    },

    async getFieldList() {
      this.loadingField = true
      try {
        return await ExtractServices.fieldList(this.reportTypeId)
      } finally {
        this.loadingField = false
      }
    },

    async getAgroindustrias() {
      this.loadingFilter.agroindustria = true
      try {
        return await agroindustryService.list(1, true)
      } finally {
        this.loadingFilter.agroindustria = false
      }
    },

    async getSupervisores() {
      this.loadingFilter.supervisor = true
      try {
        return await supervisorService.getSupervisores(1, true)
      } finally {
        this.loadingFilter.supervisor = false
      }
    },

    async getProdutores() {
      this.loadingFilter.produtor = true
      try {
        return await producerService.list(1, true)
      } finally {
        this.loadingFilter.produtor = false
      }
    },

    async getConsultores() {
      this.loadingFilter.consultor = true
      try {
        return await consultantService.getConsultores(1)
      } finally {
        this.loadingFilter.consultor = false
      }
    },

    gerarHeaders(data) {
      const headersFixos = [
        { text: 'Fazenda', value: 'fazenda' },
        { text: 'Produtor', value: 'produtor' },
        { text: 'Nome Consultor', value: 'nomeConsultor' },
      ]

      // Filtramos para não repetir o que já está no fixo
      const headersMapeados = data
        .filter(
          campo =>
            campo.fieldValue !== 'fazenda' &&
            campo.fieldValue !== 'nomeConsultor',
        )
        .map(campo => ({
          text: campo.fieldLabel,
          value: campo.fieldValue,
        }))

      return [...headersFixos, ...headersMapeados]
    },

    async fetchApiFields() {
      const loadFields = async () => {
        const fields = await this.getFieldList()
        this.apiFields = fields || []

        this.apiFields.unshift(
          {
            field_label: 'Matricula',
            field_name: 'matricula',
            field_placeholder: 'Matricula da fazenda',
            field_type: 'default',
            field_db: 'Matricula',
            join: 'fazenda',
            id: null,
          },
          {
            field_label: 'Cidade',
            field_name: 'cidade',
            field_placeholder: 'Cidade',
            field_type: 'default',
            field_db: 'Nome',
            join: 'cidade',
            id: null,
          },
          {
            field_label: 'Estado',
            field_name: 'estado',
            field_placeholder: 'Estado',
            field_type: 'default',
            field_db: 'Nome',
            join: 'estado',
            id: null,
          },
          {
            field_label: 'Número Visita',
            field_name: 'numeroVisita',
            field_placeholder: 'Número Visita',
            field_type: 'default',
            field_db: 'numeroVisita',
            // join: 'report',
            id: null,
          },
        )
      }

      const loadModelo = async () => {
        this.apiModelos = (await this.loadExtractModel()) || []
      }

      const loadAgros = async () => {
        this.agroindustrias = (await this.getAgroindustrias()) || []
      }

      const loadSups = async () => {
        this.supervisores = (await this.getSupervisores()) || []
      }

      const loadProds = async () => {
        this.produtores = (await this.getProdutores()) || []
      }

      const loadCons = async () => {
        this.consultores = (await this.getConsultores()) || []
      }

      await Promise.allSettled([
        loadFields(),
        loadModelo(),
        loadAgros(),
        loadSups(),
        loadProds(),
        loadCons(),
      ])
    },

    addEntry() {
      if (!this.currentSelection.field || !this.currentSelection.calc) return
      this.extractedDataArray.push({
        fieldId: this.currentSelection.field.id,
        fieldValue: this.currentSelection.field.field_name,
        fieldLabel: this.currentSelection.field.field_label,
        calcValue: this.currentSelection.calc.value,
        calcText: this.currentSelection.calc.text,
        fieldDB: this.currentSelection.field?.field_db
          ? this.currentSelection.field.field_db
          : null,
        join: this.currentSelection.field?.join
          ? this.currentSelection.field.join
          : null,
      })
      this.currentSelection.field = null
    },
    removeEntry(index) {
      this.extractedDataArray.splice(index, 1)
    },

    async extract() {
      Swal.fire({
        title: 'Extraindo dados...',
        text: 'Estamos processando seu relatório, aguarde um momento.',
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading()
        },
      })

      this.loadingSheet = true

      try {
        let form = {
          reportType: this.reportTypeId,
          projectId: ENV_APP.ProjectID,
          dados: this.extractedDataArray,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
          agroindustrias: this.agroSelected,
          status: this.statusSelected,
          supervisores: this.supervisorSelected,
          consultores: this.consultorSelected,
          produtores: this.produtorSelected,
        }

        let dados = await ExtractServices.extract(
          form,
          this.agroSelected,
          this.statusSelected,
        )

        // Verifica se retornou vazio
        if (!dados || dados.length == 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Relatório Vazio',
            text: 'Não encontramos dados com esses filtros!',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Entendido',
          })
          this.loadingSheet = false
          return
        }

        let header = this.gerarHeaders(this.extractedDataArray)
        new JsonToExcel(dados, header, 'Extracao.xlsx', 'Relatório')

        Swal.close()
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Erro na extração',
          text: 'Houve um problema ao buscar os dados do servidor.',
        })
      } finally {
        this.loadingSheet = false
      }
    },
  },
}
</script>
